import { t } from 'i18next';
import * as yup from 'yup';

export const upsertLogSchema = () =>
  yup.object({
    user: yup.object().label(t('labelUser')).nullable().required(),
    task: yup.object().label(t('labelTask')).nullable().required(),
    activityDate: yup.string().label(t('labelActivityDate')).nullable().required(),
    duration: yup.number().label(t('labelDurationHours')).nullable().required(),
    note: yup.string().label(t('labelNote')).nullable(),
  });
